<template>
    <div>
        <scheduler company="true" :items.sync="company.schedule"></scheduler>
        <button-loading
            class="btn btn-lg btn-primary mb-3"
            :loading="isSavePending"
            @click="saveCompany()"
        >{{$t('Save')}}
        </button-loading>
    </div>
</template>

<script>
    import Navigation from './Navigation.vue';
    import Scheduler from '@/components/Scheduler.vue';
    import {companyMixins} from './mixins.js'
    import ButtonLoading from '@/components/ButtonLoading'

    export default {
        components: {
            Navigation,
            ButtonLoading,
            Scheduler
        },
        mixins: [companyMixins],
        created() {

        }


    }
</script>
